import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  InputNumeroInteiro,
  OutlinedBtnPrimary,
  PageHeader,
  SectionTitle,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useLeadTimeRecebimentoCargaState, { LEAD_ACTIONS } from './LeadTimeRecebimentoCargaState'

export default connect()(withRouter(LeadTimeRecebimentoCarga))

function LeadTimeRecebimentoCarga({ history, dispatch }) {
  const { state, localDispatch } = useLeadTimeRecebimentoCargaState()
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    if (state.loading === LEAD_ACTIONS.FETCH_LEADS) {
      dispatch(showLoadingBox('Carregando os Lead Times . . .', 'Aguarde'))
    }
    if (state.loading === LEAD_ACTIONS.SAVE_LEADS) {
      dispatch(showLoadingBox('Salvando os Lead Times . . .', 'Aguarde'))
    } else {
      dispatch(hideLoadingBox())
    }
  }, [state.loading, dispatch])

  useEffect(() => {
    state.errorMessage &&
      dispatch(showMessageBox(null, state.errorMessage)) &&
      localDispatch.resetMessages()
  }, [state.errorMessage, dispatch])

  useEffect(() => {
    state.successMessage &&
      dispatch(showMessageBox(state.successMessage, null)) &&
      localDispatch.resetMessages()
  }, [state.successMessage, dispatch])

  // Render
  return (
    <>
      <PageHeader>2.8 - Lead Time Para Recebimento de Carga</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <SectionTitle title="Informações" />
            </div>
            <div className="p-col-3">
              <CustomDropdown
                label="Selecione a Central de Operações"
                options={state.centraisOperacao}
                value={state.selectedCentral}
                optionLabel="name"
                onChange={value => localDispatch.fetchLeadsTime(value, state.selectedEmpresa)}
              />
            </div>
            <div className="p-col-3">
              <CustomDropdown
                label="Selecione a Empresa"
                options={state.empresas}
                value={state.selectedEmpresa}
                optionLabel="name"
                onChange={value => localDispatch.fetchLeadsTime(state.selectedCentral, value)}
              />
            </div>
            <div className="p-col-12">
              <SectionTitle title="Defina o Lead Time Por Operador" />
            </div>
            <div className="p-col-12">
              <OutlinedBtnPrimary
                label="Salvar"
                onClick={() => localDispatch.onBtnSalvarClick(state.leadTimes)}
              />
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.leadTimes}
                emptyMessage="Nenhum Operador Encontrado"
                rows={10}
                paginator
                globalFilter={globalFilter}
                header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
              >
                <Column field="tp_nome" header="Operador Logístico" />
                <Column
                  header="Lead Time (Em dias)"
                  style={tableCellCentered(200)}
                  body={item => (
                    <InputNumeroInteiro
                      marginTop={0}
                      value={item.lead_time}
                      onChange={value =>
                        localDispatch.onLeadTimeChange({ ...item, lead_time: value })
                      }
                    />
                  )}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}
